import { render, staticRenderFns } from "./PbPlayer.vue?vue&type=template&id=7b225709&scoped=true&"
import script from "./PbPlayer.vue?vue&type=script&lang=js&"
export * from "./PbPlayer.vue?vue&type=script&lang=js&"
import style0 from "./PbPlayer.vue?vue&type=style&index=0&id=7b225709&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b225709",
  null
  
)

export default component.exports